import { render } from "./PageBg.vue?vue&type=template&id=139d1a44&scoped=true"
import script from "./PageBg.vue?vue&type=script&lang=js"
export * from "./PageBg.vue?vue&type=script&lang=js"

import "./PageBg.vue?vue&type=style&index=0&id=139d1a44&lang=scss&scoped=true"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139d1a44"]])

export default __exports__